/*
  Cuban Link Guy — scroll-reveal
  Adds `.reveal-in` to any element marked `.reveal-init` or `[data-reveal]`
  when it scrolls into view (mirrors the v0 framer-motion <Reveal> component).
  Honors prefers-reduced-motion: skips the animation and shows content.
*/
(function () {
  'use strict';

  function init() {
    var nodes = document.querySelectorAll('.reveal-init, [data-reveal]');
    if (!nodes.length) return;

    var reduce =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Reduced motion or no IO support: just show everything immediately.
    if (reduce || !('IntersectionObserver' in window)) {
      nodes.forEach(function (el) {
        el.classList.remove('reveal-init');
        el.classList.add('reveal-in');
        el.style.opacity = '1';
      });
      return;
    }

    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = el.getAttribute('data-reveal-delay');
          if (delay) el.style.animationDelay = delay + 'ms';
          el.classList.add('reveal-in');
          obs.unobserve(el);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    nodes.forEach(function (el) {
      el.classList.add('reveal-init');
      obs.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan when sections are re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
